import { useSearchQuestionQSetUsageRecordsQuery } from '@report/graphql';
import { Button, FileUploadOutlinedIcon } from '@shared/components';
import { useDisclosure } from '@shared/hooks';

import { useQuestionUsageByQSetReportSearchParams } from '../../hooks';
import { QSetUsageReportExportModal } from '../question-usage-by-qset-report-export-modal';

export default function QuestionUsageByQSetReportExportButton() {
  const [isModalOpen, { open: openModal, close: closeModal }] = useDisclosure();
  const [{ page, pageSize, examCourse, qSetStatus }] = useQuestionUsageByQSetReportSearchParams();

  const isSearchEmpty = !examCourse || !qSetStatus;

  const { data: qSetUsageData } = useSearchQuestionQSetUsageRecordsQuery({
    variables: {
      searchQuestionQSetUsageRecordsInput: {
        qSetStatuses: qSetStatus ? [qSetStatus] : [],
        examCourseId: examCourse,
        paging: {
          pageSize: pageSize,
          currentPage: page,
        },
      },
    },
    skip: isSearchEmpty,
  });

  const totalCount = qSetUsageData?.reportSearchQuestionQSetUsageRecords?.total ?? 0;
  const shouldDisable = totalCount === 0;

  const handleClick = () => {
    openModal();
  };

  return (
    <>
      <Button
        variant='outlined'
        color='secondary'
        startIcon={<FileUploadOutlinedIcon />}
        onClick={handleClick}
        disabled={shouldDisable}
      >
        Export
      </Button>
      <QSetUsageReportExportModal open={isModalOpen} onClose={closeModal} totalCount={totalCount} />
    </>
  );
}
